import { ApproveWeekRequest } from '@siteday/shared';
import { z } from 'zod';

import { api, buildUrl } from './client';

/** GET /reports/weekly?jobId=&weekStart=&format=pdf|csv (doc 05 Reports). */
export const weeklyReportUrl = (jobId: string, weekStart: string, format: 'pdf' | 'csv') =>
  buildUrl('/reports/weekly', { jobId, weekStart, format });

export const approveWeekViaReports = (jobId: string, weekStart: string) =>
  api.post(
    '/reports/weekly/approve',
    ApproveWeekRequest.parse({ jobId, weekStart }),
    z.object({ approved: z.number().int() }).passthrough(),
  );
